var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5884 0H24.4116C28.6027 0 32 3.39732 32 7.5884V24.4116C32 28.6027 28.6027 32 24.4116 32H7.5884C3.39731 32 0 28.6027 0 24.4116V7.5884C0 3.39732 3.39798 0 7.5884 0Z",
    fill: "#F9191D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6973 7.66797H9.33958C6.93712 7.66797 4.98975 9.61534 4.98975 12.0178V19.8556C4.98975 22.258 6.93712 24.2054 9.33958 24.2054H22.6973C25.0998 24.2054 27.0472 22.258 27.0472 19.8556V12.0178C27.0465 9.61534 25.0991 7.66797 22.6973 7.66797Z",
    fill: "#F8FAF8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7705 19.5635V12.3098C12.7705 11.7363 13.3956 11.3818 13.8877 11.6761L19.9494 15.303C20.4283 15.5894 20.4283 16.2833 19.9494 16.5697L13.8877 20.1965C13.3956 20.4909 12.7705 20.1364 12.7705 19.5635Z",
    fill: "#F9191D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.cd42f440023288ca69cc0f27c8e72c40.svg";
export { ForwardRef as ReactComponent };